// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { push } from 'react-router-redux';
import { actions as OrderActions } from '../duck';
import { actions as AlertActions } from '../../alert/duck';
import Order from '../components/Order';

import type { RootState } from '../../index';

function mapStateToProps(state: RootState) {
  return {
    user: state.auth.user,
    order: state.order.order,
    isFetchingOrder: state.order.isFetchingOrder,
    localValues: state.localValues,
    isFetchingMessages: state.order.isFetchingMessages,
    messages: state.order.messages,
    fetchMessagesError: state.order.fetchMessagesError,
    fetchOrderError: state.order.fetchOrderError,
    locale: state.locale,
  };
}

function mapDispatchToProps(dispatch: Function) {
  return bindActionCreators({
    ...OrderActions,
    ...AlertActions,
    goToRedirect: (route: string) => push(route),
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Order);



// WEBPACK FOOTER //
// ./src/modules/order/containers/OrderContainer.js